import { SvgIcon, type SvgIconProps } from './svgIcon'

export const SecurityIcon = ({
  width = 16,
  height = 19,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox={`0 0 16 19`} {...props}>
    <path
      d="M7.99997 19.4807C5.83716 18.891 4.04646 17.6179 2.62787 15.6615C1.20929 13.7051 0.5 11.5179 0.5 9.10001V3.34619L7.99997 0.538513L15.5 3.34619V9.10001C15.5 11.5179 14.7907 13.7051 13.3721 15.6615C11.9535 17.6179 10.1628 18.891 7.99997 19.4807ZM7.99997 17.9C9.61664 17.4 10.9666 16.4125 12.05 14.9375C13.1333 13.4625 13.7666 11.8167 13.95 10H7.99997V2.13464L1.99997 4.37501V9.54039C1.99997 9.66347 2.01664 9.81668 2.04997 10H7.99997V17.9Z"
      fill="currentColor"
    />
  </SvgIcon>
)
